import { call, put, select, takeLatest } from "redux-saga/effects";
import { getType } from "typesafe-actions";
import { createNotificationActions, notificationActions } from "./notifications.actions";
import { createNotificationApi, getNotificationApi } from "./notifications.api";
import { AppNotificationDto } from "./notifications.dto";

function* handleGetNotification(request: ReturnType<typeof notificationActions.request>) {
    const storeNotification: AppNotificationDto = yield select(state => state.appNotifications.notification);
    const notification: AppNotificationDto = (storeNotification !== undefined && storeNotification.id !== undefined && storeNotification.id === request.payload) ? storeNotification : yield call(getNotificationApi, request.payload);
  
    yield put({ type: getType(notificationActions.success), payload: notification });
}
  
function* handleCreateNotification(request: ReturnType<typeof createNotificationActions.request>) {
    const createdNotification: AppNotificationDto = yield call(createNotificationApi, request.payload);
  
    yield put({ type: getType(notificationActions.success), payload: createdNotification });
}

export function* watchGetNotificationRequest() {
    try {
      yield takeLatest(getType(notificationActions.request), handleGetNotification);
    }
    catch (err) {
      console.log(err);
    }
}

export function* watchCreateNotificationRequest() {
    try {
      yield takeLatest(getType(createNotificationActions.request), handleCreateNotification);
    }
    catch (err) {
      console.log(err);
    }
}